var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',[_c('Banner',{attrs:{"dataimgs":_vm.dataimgs}}),_vm._v(" "),_c('IndustryIntro',{attrs:{"data":_vm.intros}}),_vm._v(" "),_c('IndustryPainSpot',{attrs:{"data":_vm.pains}}),_vm._v(" "),_c('Decoration'),_vm._v(" "),_c('IndustryArc',{attrs:{"data":_vm.arcImg}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10018bac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/fastclass-loader!./src/components/PortalIndustry.vue
// module id = null
// module chunks = 